export async function smallDetailListProviders(){
    const baseLink = process.env.REACT_APP_END_POINT_BASE;
    
    let finalRes = await fetch(baseLink + 'providers/quickList', {  // Replace with your API endpoint
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
    .then(async response => {
        if (!response.ok) {
            const errorData = await response.json();
            return await errorData;
        } else {
            const successData = await response.json();
            return await successData;
        }
    })
    .then(data => {
        //add message of new email
        return data.result;
    })
    .catch(error => {
        return { isOk: false, message: error.message } ;
        // Handle the error, e.g., display an error message
    });
    return finalRes;
}

export async function localfarmsList() {
    const baseLink = process.env.REACT_APP_END_POINT_BASE;
    let finalRes = await fetch(baseLink + 'providers/detailsWithVisibleCodeLocalFarmList', {  // Replace with your API endpoint
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
    .then(async response => {
        if (!response.ok) {
            const errorData = await response.json();
            return await errorData;
        } else {
            const successData = await response.json();
            return await successData;
        }
    })
    .then(data => {
        //add message of new email
        return data;
    })
    .catch(error => {
        return { isOk: false, message: error.message } ;
    });

    return finalRes;
}

export async function  detaillsProviders(visibleCode) {
    const baseLink = process.env.REACT_APP_END_POINT_BASE;
    let finalRes = await fetch(baseLink + 'providers/detailsWithVisibleCode/' + visibleCode, {  // Replace with your API endpoint
        method: 'GET',
        params: 
        {
            visibleCode: visibleCode
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
    .then(async response => {
        if (!response.ok) {
            const errorData = await response.json();
            return await errorData;
        } else {
            const successData = await response.json();
            return await successData;
        }
    })
    .then(data => {
        //add message of new email
        return data;
    })
    .catch(error => {
        return { isOk: false, message: error.message } ;
    });

    return finalRes;
}